import React from "react";
import Trainings from "./Trainings";
import Sidebar from "../sidebar/Sidebar";
import { useEffect, useState } from "react";
import ProgramsModal from "./modals/ProgramsModal";
import ChallengeModal from "./modals/ChallengeModal";
import GroupsModal from "./modals/GroupsModal";
import Progress from "./Progress";
import { Services } from "../../api/Services";
import { useNavigate, useLocation } from "react-router-dom";
import peoplesvg from "../../images/people.svg";
import Workouts from "./Workouts";

import Programsvg from "../../images/programsvg.svg";

import groupsvg from "../../images/groups.svg";

import challengsvg from "../../images/challeges.svg";

import progressvg from "../../images/progress.svg";
import placeholder from "../../images/placeholder.png";
import Trainingsvg from "../../images/training.svg";

import Activitiessvg from "../../images/activities.svg";

import TrainerPrograms from "./TrainerPrograms";
import TrainerGroups from "./TrainerGroups";
import TrainerChallenges from "./TrainerChallenges";
import TrainerActivities from "./TrainerActivities";
import UserStats from "./UserStats";
// Set the locale globally (optional)

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DropdownComponent from "./DropDown";
import AssignProgram from "./AssignForm";
import { BASE_URL_MEDIA } from "../../api/Constants";
import { BASE_URL_COMPETITION } from "../../api/Constants";
import { getImageUrl } from 'components/helpers/Helpers';

const Dashboard = () => {
  const location = useLocation();

  // Parse the query parameter from the location search string
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const navigate = useNavigate();

  const isLoggedIn = localStorage.getItem("token");
  const [allStats, setAllStats] = useState({});
  const [isClient, setIsClient] = useState(true);
  const [isProgram, setIsProgram] = useState(false);
  const [isGroup, setIsGroup] = useState(false);
  const [isChallenge, setIsChallenge] = useState(false);
  const [isActivity, setIsActivity] = useState(false);
  const [clientSpecs, setClientSpecs] = useState({});
  const [clientimg, setClientimg] = useState("");
  const [clientname, setClientname] = useState("");
  const [activeid, setActiveid] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isProgress, setIsProgress] = useState(false);
  const [isTraining, setIsTraining] = useState(true);
  const [isWorkouts, setIsWorkouts] = useState(false);
  const [showModal, setShowModal] = useState(false);

  // Temporary List
  const [lists, setLists] = useState([
    // { name: "All", id: 337533432 },
    { name: "Programs", id: 33753343432 },
    { name: "Groups", id: 725243432 },
  ]);

  // tab secltion form the tabar
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [selectedClients, setSelectedClients] = useState([]);
  const [showClients, setShowClients] = useState([]);
  const [searchUserinput, setSearchUserinput] = useState("");
  const [isLoadingClients, setIsLoadingClients] = useState(true);
  const [isLoadingStats, setIsLoadingStats] = useState(true);

  // for clinets list setting box options
  const [showSetting, setShowSetting] = useState(false);
  const [settingIndex, setSettingIndex] = useState(null);
  const [assignDataForm, setAssignDataForm] = useState(false);
  const [isAssignProgram, setIsAssignProgram] = useState(false);

  //client specs details states
  //  For Programs

  const [programModal, setprogramModal] = useState(false);

  //For groups
  const [groupModal, setGroupModal] = useState(false);

  //For Challenges
  const [challengeModal, setChallengeModal] = useState(false);

  //api call for get trainer clients

  useEffect(() => {
    if (token) {
      setIsTraining(true);
      localStorage.setItem("token", token);
      const url = new URL(window.location.href);
      url.searchParams.delete("token");
      window.history.replaceState(null, "", url);

      userProfile();
    }
    if (!isLoggedIn && !token) {
      navigate("/trainer");
    }
  }, [token]);

  //===================>> Over all trainer stats function start =========================>>
  const getAllstats = async () => {
    try {
      const result = await Services.getTrainerDashboardStats();

      if (result?.status === 401) {
          setIsLoading(false);
          localStorage.clear();
          navigate("/trainer/");
      }else if (result) {
        setAllStats(result?.data?.data);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  //api call for user profile data
  const userProfile = async (id) => {
    const prams = "";
    setIsLoading(true);
    try {
      const result = await Services.getUserProfile(prams);

      if (result?.status === 401) {
          setIsLoading(false);
          localStorage.clear();
          navigate("/trainer/");
      }else if (result) {
        localStorage.setItem("id", result?.data?.data?.id);
        localStorage.setItem("trainername", result?.data?.data?.name);
        localStorage.setItem("traineremail", result?.data?.data?.email);
        localStorage.setItem("trainerimage", result?.data?.data?.image);
        localStorage.setItem("trainerphone", result?.data?.data?.phone);
        localStorage.setItem("trainergender", result?.data?.data?.gender);
        localStorage.setItem("trainerjoined", result?.data?.data?.created_at);
        if(result?.data?.data?.corporate_identifier){
          localStorage.setItem("corporate_identifier	", result?.data?.data?.corporate_identifier);
        }
        navigate("/dashboard");
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  //===================>>  trainer clients stats function start =========================>>
  /* Code Chsnged by Zohaib Start  */
  //api call for get trainer clients

  const getTrainerClients = async (index) => {
    setIsLoadingClients(true);
    setIsLoading(true);
    if (selectedTabIndex <= 1 || index <= 1) setIsLoading(true);
    try {
      let result;
      // changing the list of clints based on the selected the type
      if (index === 1)
        result = await Services.getTrainerDashboardClients("groups");
      else if (index === 0)
        result = await Services.getTrainerDashboardClients("programs");
      // else if (index === 0)
      //   result = await Services.getTrainerDashboardClients("all");

      if (selectedTabIndex <= 1 || index <= 1) {
        if (result) {
          setIsLoading(false);
          setSelectedClients(result?.data?.data?.clients);
          getTrainerClientsSpecs(
            result?.data?.data?.clients[0].id,
            result?.data?.data?.clients[0].image,
            result?.data?.data?.clients[0].name
          );
        } else {
          toast.error(result.data.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } else {
        setIsLoadingClients(false);
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoadingClients(false);
  };

  //Hanlde user input to cahnge clients in form while seraching
  const handleuserinputChange1 = async (event) => {
    const newInputValue = event ? event.target.value : "";
    setSearchUserinput(newInputValue);

    try {
      if (newInputValue.trim() === "") {
        setSearchUserinput("");
        setShowSetting(false);
      } else {
        setShowSetting(false);
        const filteredClients = selectedClients.filter((client) =>
          selectedTabIndex > 1
            ? client.user.name
                .toLowerCase()
                .includes(newInputValue.toLowerCase()) ||
              client.user.email
                .toLowerCase()
                .includes(newInputValue.toLowerCase())
            : client.name.toLowerCase().includes(newInputValue.toLowerCase()) ||
              client.email.toLowerCase().includes(newInputValue.toLowerCase())
        );
        setShowClients(filteredClients);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // for displaying the assing form
  const showAssignForm = (client) => {
    return (
      <AssignProgram
        setAssignDataForm={setAssignDataForm}
        getTrainerClientsSpecs={getTrainerClientsSpecs}
        client={client}
        setShowSetting={setShowSetting}
        isAssignProgram={isAssignProgram}
      />
    );
  };

  const handleUserListClick = async (client) => {
    selectedTabIndex > 1
      ? await getTrainerClientsSpecs(
          client.user?.id,
          client.user?.image,
          client.user?.name
        )
      : await getTrainerClientsSpecs(client?.id, client?.image, client?.name);
  };
  /* Code Chsnged by Zohaib Start  */

  //api call for single client specs
  const getTrainerClientsSpecs = async (id, img, name) => {
    setIsLoadingStats(true);
    setIsProgress(false);
    setClientimg(img);
    setClientname(name);
    setActiveid(id);
    setIsLoading(true);
    try {
      const result = await Services.getTrainerDashboardClientStats(id);


      if (result?.status === 401) {
          setIsLoading(false);
          setIsLoadingStats(false);
          localStorage.clear();
          navigate("/trainer/");
      }else if (result) {
        setClientSpecs(result?.data?.data);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setIsLoadingStats(false);
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoadingStats(false);
  };

  //function to show trainer clients
  const getClients = (tabSelected = false) => {
    
      getTrainerClients(0);
      console.log("Client Tab selected");
      setIsClient(true);
      setIsProgram(false);
      setIsGroup(false);
      setIsChallenge(false);
      setIsActivity(false);
      localStorage.setItem("dashboard_selectedTabIndex", 0);
  };

  //===================>> Over all trainer stats function end =========================>>

  //===================>> Trainer program section start =========================>>
  //start functions to call programs
  const showPrograms = () => {
    setIsProgram(true);
    setIsClient(false);
    setIsGroup(false);
    setIsChallenge(false);
    setIsActivity(false);
    localStorage.setItem("dashboard_selectedTabIndex", 1);
  };

  const showGroups = () => {
    setIsProgram(false);
    setIsClient(false);
    setIsGroup(true);
    setIsChallenge(false);
    setIsActivity(false);
    localStorage.setItem("dashboard_selectedTabIndex", 2);
  };
  const showChallenges = () => {
    setIsProgram(false);
    setIsClient(false);
    setIsGroup(false);
    setIsChallenge(true);
    setIsActivity(false);
    localStorage.setItem("dashboard_selectedTabIndex", 3);
  };
  const showActivities = () => {
    setIsProgram(false);
    setIsClient(false);
    setIsGroup(false);
    setIsChallenge(false);
    setIsActivity(true);
    localStorage.setItem("dashboard_selectedTabIndex", 4);
  };
  //===================>> Trainer program section end =========================>>

  useEffect(() => {

    const dashboard_selectedTabIndex = localStorage.getItem("dashboard_selectedTabIndex") ?? 0;
    console.log("dashboard_selectedTabIndex=",dashboard_selectedTabIndex);
    getAllstats();
    if(dashboard_selectedTabIndex == 1 || dashboard_selectedTabIndex == null){
       setSelectedTabIndex(dashboard_selectedTabIndex);
      if (dashboard_selectedTabIndex == 1){
          showPrograms();
      }
    }else{
      getClients(true);
    }
  }, []);

  const showUserStats = () => {
    //setShowModal(true);
    const metaToken = localStorage.getItem("token");
    const url = `${BASE_URL_COMPETITION}/user/${activeid}${metaToken ? "?token=" + metaToken : ""}`;
    window.open(url, "_blank");
  };
  const showGroupProfile = (gid) => {
    //setShowModal(true);
    const metaToken = localStorage.getItem("token");
    const url = `${BASE_URL_COMPETITION}/all-groups?tab=view-members&g-id=/${gid}${metaToken ? "?token=" + metaToken : ""}`;
    window.open(url, "_blank");
  };
  
  return (
    <div className="wrapper-dashboard">
      {activeid && showModal && (
        <div className="trainer-modal-eventWrapper trainer-modal-eventWrapper-upper">
          <div className="trainer-modal trainer-modal-lg">
            <div className="close" onClick={() => setShowModal(false)}>
              <i className="fa fa-times"></i>
            </div>
            <UserStats userId={activeid} />
          </div>
        </div>
      )}

      {/* Client programs modal */}
      {programModal && (
        <ProgramsModal setprogramModal={setprogramModal} activeid={activeid} />
      )}

      {/* Client Groups modal */}
      {groupModal && (
        <GroupsModal setGroupModal={setGroupModal} activeid={activeid} />
      )}

      {/* Client Challenge modal */}
      {challengeModal && (
        <ChallengeModal
          setChallengeModal={setChallengeModal}
          activeid={activeid}
        />
      )}

      <div className="left">
        <Sidebar />
      </div>
      <div className="right">
        {isLoading && (
          <div className="loaderparent">
            <div className="loader"></div>
          </div>
        )}
        <div className="dashboard-items">
          <div
            className={`${isClient ? "active item" : "item"}`}
            onClick={() => getClients(true)}
          >
            <div className="icon">
              <img src={peoplesvg} />
            </div>
            <p className="title">Total active clients</p>
            {allStats?.total_clients && (
              <p className="subtitle">
                <span>{allStats?.total_clients}</span>
              </p>
            )}
          </div>
          <div
            className={`${isProgram ? "active item" : "item"}`}
            onClick={() => showPrograms()}
          >
            <div className="icon">
              <img src={Programsvg} />
            </div>
            <p className="title">Programs & Workouts</p>
            {allStats?.total_programs && (
              <p className="subtitle">
                <span>{allStats?.total_programs}</span>
              </p>
            )}
          </div>

          <div
            className={`${isGroup ? "active item" : "item"}`}
            onClick={() => showGroups()}
          >
            <div className="icon">
              <img src={groupsvg} />
            </div>
            <p className="title">Total groups</p>
            {allStats?.total_groups > 0 ? (
              <p className="subtitle">
                <span>{allStats?.total_groups}</span>
              </p>
            ) : (
              <p className="subtitle">
                <span>0</span>
              </p>
            )}
          </div>
          <div
            className={`${isChallenge ? "active item" : "item"}`}
            onClick={() => showChallenges()}
          >
            <div className="icon">
              <img src={challengsvg} />
            </div>
            <p className="title">Total Challenges</p>
            {allStats?.total_challeges > 0 ? (
              <p className="subtitle">
                <span>{allStats?.total_challeges}</span>
              </p>
            ) : (
              <p className="subtitle">
                <span>0</span>
              </p>
            )}
          </div>
          <div
            className={`${isActivity ? "active item" : "item"}`}
            onClick={() => showActivities()}
          >
            <div className="icon">
              <img src={Activitiessvg} />
            </div>
            <p className="title">Future Activities</p>
            {allStats?.total_activities && (
              <p className="subtitle">
                <span>{allStats?.total_activities}</span>
              </p>
            )}
          </div>
        </div>

        <div className="main-dashboard-container">
          {/* JSX for clients */}
          {isClient && (
            <div className="client_info__wrapper">
              <div className="row">
                <div className="col-12 col-md-2">
                  {/* Code Modified by Zohaib Satrt*/}
                  <DropdownComponent
                    setShowSetting={setShowSetting}
                    setIsLoadingClients={setIsLoadingClients}
                    getTrainerClients={getTrainerClients}
                    selectedClients={selectedClients}
                    setSelectedClients={setSelectedClients}
                    lists={lists}
                    setLists={setLists}
                    selectedTabIndex={selectedTabIndex}
                    setSelectedTabIndex={setSelectedTabIndex}
                    setSearchUserinput={setSearchUserinput}
                    getTrainerClientsSpecs={getTrainerClientsSpecs}
                  />

                  <div className="clients-profiles-search-box">
                    <label htmlFor="searchInput">
                      <i className="fa fa-search srach-user-icon"></i>{" "}
                    </label>
                    <input
                      type="text"
                      id="searchInput"
                      value={searchUserinput}
                      onChange={handleuserinputChange1}
                      placeholder="Search users"
                      className="Search-input"
                    />
                  </div>

                  <div className="clients-profiles">
                    {!isLoadingClients ? (
                      (searchUserinput === ""
                        ? selectedClients
                          ? selectedClients
                          : []
                        : showClients
                        ? showClients
                        : []
                      ).map((client, index) => (
                        <>
                          <div
                            className={`${
                              (selectedTabIndex > 1
                                ? client?.user?.id
                                : client?.id) == activeid
                                ? " active profile_wrapper "
                                : "profile_wrapper"
                            }`}
                          >
                            <div
                              className="clinet-details"
                              onClick={() => {
                                handleUserListClick(client);
                                setShowSetting(false);
                              }}
                            >
                              {(
                                selectedTabIndex > 1
                                  ? client?.user?.image
                                  : client?.image
                              ) ? (
                                <img
                                  className="placerholder-small"
                                  src = {selectedTabIndex > 1 ? getImageUrl(client?.user?.image, BASE_URL_MEDIA)
                                    : getImageUrl(client?.image, BASE_URL_MEDIA)
                                  }
                                  alt=""
                                />
                              ) : (
                                <div className="placerholder-small">
                                  {selectedTabIndex > 1
                                    ? client?.user?.name.slice(0, 1)
                                    : client?.name.slice(0, 1)}
                                </div>
                              )}

                              <p className="name">
                                {selectedTabIndex > 1
                                  ? client?.user?.name
                                  : client?.name}
                              </p>
                            </div>

                            <div
                              className="dash-c-setting-icon"
                              onClick={() => {
                                if (showSetting && settingIndex === index)
                                  setShowSetting(false);
                                else {
                                  setShowSetting(false);
                                  setShowSetting(true);
                                  setSettingIndex(index);
                                  handleUserListClick(client);
                                }
                              }}
                            >
                              <i
                                class={
                                  settingIndex === index && showSetting
                                    ? "fa fa-cog fa-spin"
                                    : "fa fa-cog"
                                }
                                title="List Settings"
                              ></i>
                            </div>
                          </div>
                          {showSetting && settingIndex === index && (
                            <div className="show-options">
                              <div
                                className="list-setting"
                                key={index}
                                onClick={() => {
                                  setIsAssignProgram(true);
                                  setAssignDataForm(true);
                                }}
                              >
                                <i
                                  className="fa-solid fa-plus"
                                  title="Assign Program"
                                ></i>
                                <p>Assign Program</p>
                              </div>
                              <div
                                className="list-setting"
                                key={index}
                                onClick={() => {
                                  setAssignDataForm(true);
                                  setIsAssignProgram(false);
                                }}
                              >
                                <i
                                  className="fa-solid fa-plus"
                                  title="Assign Group"
                                ></i>
                                <p>Assign Group</p>
                              </div>
                            </div>
                          )}
                          {settingIndex === index &&
                            assignDataForm &&
                            (selectedTabIndex > 1
                              ? showAssignForm(client.user)
                              : showAssignForm(client))}
                        </>
                      ))
                    ) : (
                      <div className="list-name-loading-clients">
                        <div className="list-name-loading-gap-clients"></div>
                        <div className="three-body">
                          <div className="three-body__dot"></div>
                          <div className="three-body__dot"></div>
                          <div className="three-body__dot"></div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/* Code Modified by Zohaib Satrt*/}
                {clientname && (
                  <div className="col-12 col-md-10">
                    {!isLoadingStats ? (
                      <>
                        <div className="client_specs-detail">
                          <div className="header">
                            <div>
                              {clientimg ? (
                                <img
                                  src={getImageUrl(clientimg, BASE_URL_MEDIA)}
                                />
                              ) : (
                                <img src={placeholder} />
                              )}

                              <span className="name">{clientname}</span>
                            </div>
                            <span
                              onClick={() => {
                                //showUserStats()
                                const metaToken = localStorage.getItem("token");
                                const url = `${BASE_URL_COMPETITION}/user/${activeid}${metaToken ? "?token=" + metaToken : ""}`;
                                window.open(url, "_blank");
                              }}
                              style={{
                                fontSize: "12px",
                                color: "#4E10FF",
                                cursor: "pointer",
                              }}
                            >
                              {" "}
                              View Profile{" "}
                              <i
                                title="View Profile"
                                class="fa-regular fa-eye"
                              ></i>
                            </span>
                          </div>
                          <div className="item__wrapper">
                            <div
                              className={`${
                                isTraining ? "item active" : "item"
                              }`}
                              onClick={() => {
                                setIsTraining((pro) => !pro);
                                setIsProgress(false);
                                setIsWorkouts(false);
                              }}
                            >
                              <div className="left">
                                <img src={Trainingsvg} alt="" />
                                <span className="name">Add client data</span>
                              </div>
                            </div>
                            <div
                              className="item"
                              onClick={() => {
                                setprogramModal(true);
                                setIsProgress(false);
                                setIsTraining(false);
                              }}
                            >
                              <div className="left">
                                <img src={Programsvg} alt="" />
                                <span className="name">Programs assigned </span>
                              </div>
                              <div className="count">
                                {clientSpecs?.program_assigned}
                              </div>
                            </div>
                            <div
                              className="item"
                              onClick={() => {
                                setGroupModal(true);
                                setIsProgress(false);
                                setIsTraining(false);
                              }}
                            >
                              <div className="left">
                                <img src={groupsvg} alt="" />
                                <span className="name">Groups</span>
                              </div>
                              <div className="count">
                                {" "}
                                {clientSpecs?.groups}
                              </div>
                            </div>
                            <div
                              className={`${
                                challengeModal ? "item active" : "item"
                              }`}
                              onClick={() => {
                                setChallengeModal(true);
                                setIsProgress(false);
                                setIsTraining(false);
                              }}
                            >
                              <div className="left">
                                <img src={challengsvg} alt="" />
                                <span className="name">Challeges</span>
                              </div>
                              <div className="count">
                                {" "}
                                {clientSpecs?.challeges}
                              </div>
                            </div>
                            <div
                              className={`${
                                isWorkouts ? "item active" : "item"
                              }`}
                              onClick={() => {
                                setIsWorkouts((pro) => !pro);
                                setIsProgress(false);
                                setIsTraining(false);
                              }}
                            >
                              <div className="left">
                                <img src={Trainingsvg} alt="" />
                                <span className="name">WOD</span>
                              </div>
                              <div className="count"> {clientSpecs?.wod}</div>
                            </div>
                            <div
                              className={`${
                                isProgress ? "item active" : "item"
                              }`}
                              onClick={() => {
                                setIsProgress((pro) => !pro);
                                setIsTraining(false);
                                setIsWorkouts(false);
                              }}
                            >
                              <div className="left">
                                <img src={progressvg} alt="" />
                                <span className="name">WOD Report</span>
                              </div>
                              <div className="count">
                                {" "}
                                {clientSpecs?.progress}
                              </div>
                            </div>
                          </div>
                          {/* Trainering section start here */}

                          {isTraining && <Trainings activeid={activeid} />}
                          {/* Trainering section end here */}
                          {/* Quick workout section start here */}
                          {isWorkouts && <Workouts activeId={activeid} />}
                          {/* Quick workout section end here */}
                        </div>
                        {/* Progress component */}
                        {isProgress && <Progress activeId={activeid} />}
                      </>
                    ) : (
                      <div className="list-name-loading-clients">
                        <div className="list-name-loading-gap-clients"></div>
                        <div className="three-body">
                          <div className="three-body__dot"></div>
                          <div className="three-body__dot"></div>
                          <div className="three-body__dot"></div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* jsx end for clients */}

          {/* jsx start for programs */}

          {isProgram && (
            <div className="program-dashboards">
              <TrainerPrograms />
            </div>
          )}

          {/* jsx end for programs */}

          {/* jsx start for groups */}
          {isGroup && <TrainerGroups />}
          {isActivity && <TrainerActivities />}

          {isChallenge && <TrainerChallenges />}

          {/* jsx end for groups */}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
